// src/config/locations.js
const locations = [
  // Most visited locations at the top
  "Bangalore",
  "Mysuru",
  "Tumakuru",
  // Remaining locations in alphabetical order
  "Anekal",
  "Bagalkot",
  "Ballari",
  "Bangarpet",
  "Bantwal",
  "Basavakalyana",
  "Belagavi",
  "Belawadi",
  "Bettahalsur",
  "Bhalki",
  "Bhatkala",
  "Bidadi",
  "Bidar",
  "Brahmpur",
  "Chamarajanagara",
  "Chickballapur",
  "Chickmagalur",
  "Chikkodi",
  "Chitradurga",
  "Dakshina Kannada",
  "Davangere",
  "Devagiri",
  "Dharwad",
  "Gadag",
  "Gubbi",
  "Gulbarga",
  "Haliyal",
  "Hassan",
  "Hosapete",
  "Hubballi",
  "Hulkoti",
  "Huvina Hadagali",
  "Kalburgi",
  "Kandali",
  "Karwar",
  "Kolar",
  "K R Pet",
  "K R puram",
  "Kenjar",
  "Kodagu",
  "Kushalnagar",
  "Laxmeshwara",
  "Machche",
  "Maddur Taluk",
  "Mandya",
  "Mangaluru",
  "Moodabidri",
  "Moselehosahalli",
  "Muddenahalli",
  "Mudhol",
  "Mukka",
  "Nagamangala",
  "Naragund",
  "Nippani",
  "Nitte",
  "Rajapur",
  "Ramanagara",
  "Raichur",
  "Ranebennur",
  "R.T Nagar Post",
  "Roza",
  "Shivamogga",
  "Somanahalli",
  "Sullia",
  "Talakal",
  "Thandarapura",
  "Thodar",
  "Tiptur",
  "Udupi",
  "Udyambhag",
  "Vijayapur",
  "Viprasainagar",
  "Yadigir"
];

export default locations;
